import { RULE_FREQUENCY } from "Types/automationTypes";
import { KEYS, NAMESPACE } from "./i18n/automationRuleTable.i18n";

export function getFrequencyText($app, frequency) {
    if (frequency === RULE_FREQUENCY.EveryTime) {
        return $app.res({ namespace: NAMESPACE, key: KEYS.frequencyEveryTimeMessage });
    }
    return $app.res({ namespace: NAMESPACE, key: KEYS.frequencyOnlyFirstMessage });
}
export function getConditionText($app, formula) {
    if (formula) {
        return formula.Name;
    }
    return $app.res({ namespace: NAMESPACE, key: KEYS.conditionAlwaysMessage });
}
export function getContinueProcessingText($app, stopFurtherProcessing) {
    if (stopFurtherProcessing) {
        return $app.res({ namespace: NAMESPACE, key: KEYS.stopProcessingMessage });
    }
    return $app.res({ namespace: NAMESPACE, key: KEYS.continueProcessingMessage });
}
